import React, { useState } from "react";
import "./BusinessGainsSection.css";

const BusinessGainsSection = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const gainsData = [
    {
      title: "Réduction des coûts opérationnels",
              subtitle: "Économies significatives sur vos charges",
      details: [
        "Suppression des appels téléphoniques répétitifs",
        "Réduction du temps administratif de 60%",
        "Diminution des erreurs de planification",
        "Optimisation des trajets et économies de carburant",
        "Automatisation des confirmations de rendez-vous"
      ]
    },
    {
      title: "Gain de temps considérable", 
      subtitle: "3h par jour récupérées en moyenne",
      details: [
        "Planification automatique des créneaux",
        "Gestion intelligente des conflits d'horaires",
        "Envoi automatique des confirmations",
        "Réduction des no-show grâce aux rappels automatiques",
        "Interface intuitive pour un gain d'efficacité immédiat"
      ]
    },
    {
      title: "Augmentation du chiffre d'affaires",
              subtitle: "Croissance facilitée par l'automatisation",
      details: [
        "Optimisation du taux de remplissage des créneaux",
        "Réduction des créneaux vides de 50%",
        "Meilleure satisfaction client = plus de recommandations",
        "Capacité à traiter plus de demandes sans embaucher",
        "Suivi précis des performances et de la rentabilité"
      ]
    },
    {
      title: "Amélioration de la productivité",
      subtitle: "Efficacité opérationnelle optimisée",
      details: [
        "Planification géographique intelligente des interventions",
        "Réduction des temps de déplacement de 30%",
        "Priorisation automatique des urgences",
        "Gestion multi-techniciens simplifiée",
        "Reporting automatique et tableaux de bord en temps réel"
      ]
    },
    {
      title: "Satisfaction client améliorée",
      subtitle: "Service disponible 24h/24",
      description: "Vos clients peuvent prendre rendez-vous à tout moment, même en dehors des heures de bureau. Cela améliore considérablement leur satisfaction et augmente vos chances de conversion.",
      benefits: [
        "Disponibilité permanente",
        "Réponse instantanée",
        "Meilleure satisfaction client = plus de recommandations",
        "Réduction des rendez-vous manqués"
      ]
    },
    {
      title: "Croissance de votre activité",
      subtitle: "Scalabilité sans limite",
      description: "Un employé a ses limites. Notre IA s'adapte à votre croissance sans coût supplémentaire. Vous pouvez doubler votre activité sans doubler vos coûts.",
      benefits: [
        "Pas de limite de capacité",
        "Croissance sans recrutement",
        "Adaptation automatique à la demande",
        "Croissance durable et scalable de votre activité"
      ]
    }
  ];

  return (
    <section className="business-gains-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Les gains concrets pour votre entreprise
          </h2>
          <p className="section-subtitle">
            Découvrez comment Monagora transforme votre activité avec des résultats mesurables dès le premier mois
          </p>
        </div>

        <div className="gains-accordions">
          {gainsData.map((gain, index) => (
            <div 
              key={index} 
              className={`accordion-item ${activeAccordion === index ? 'active' : ''}`}
            >
              <div 
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                <div className="accordion-title-content">
                  <h3>{gain.title}</h3>
                  <p>{gain.subtitle}</p>
                </div>
                <div className="accordion-toggle">
                  {activeAccordion === index ? '−' : '+'}
                </div>
              </div>
              
              <div className="accordion-content">
                <div className="accordion-details">
                  <ul>
                    {gain.details.map((detail, detailIndex) => (
                      <li key={detailIndex}>
                        <span className="detail-bullet">✓</span>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gains-summary">
          <div className="summary-stats">
            <div className="stat-item">
              <div className="stat-number">40%</div>
              <div className="stat-label">Réduction des coûts</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">3h</div>
              <div className="stat-label">Gagnées par jour</div>
            </div>
                    <div className="stat-item">
          <div className="stat-number">Scalable</div>
          <div className="stat-label">Croissance sans limite</div>
        </div>
                    <div className="stat-item">
          <div className="stat-number">24h/24</div>
          <div className="stat-label">Disponibilité</div>
        </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessGainsSection; 